import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  params: {},
  byId: {},
  carerStudents: {
    byId: {},
  },
  plotcourses: {
    byId: {},
  },
  plottasks: {
    byId: {},
  },
  academic_reports: {
    byId: {},
  },
  absence_summary: {
    byId: {},
  },
  learning_behaviour: {
    byId: {},
  },
  learning_goals: {
    byId: {},
  },
  homeroom_comments: {
    byId: {},
  },
  studentList: {
    studentListData: {},
  },
  studentNotes: {
    notes: {}
  },
  sendNote: {
    status: ''
  },
  actionsloading: false,
  error: '',
});

export function parentDashboardReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_CARER_STUDENTS:
      return {
        ...state,
        actionsloading: true,
        carerStudents: {
          ...state.carerStudents,
          byId: {},
        },
      };
    case actionTypes.GET_PLOT_COURSES:
      return {
        ...state,
        actionsloading: true,
        plotcourses: {
          ...state.plotcourses,
          byId: {},
        },
        plottasks: {
          ...state.plottasks,
          byId: {},
        },
      };
    case actionTypes.GET_PLOT_TASK:
      return {
        ...state,
        actionsloading: true,
        plotcourses: {
          ...state.plotcourses,
          byId: {},
        },
        plottasks: {
          ...state.plottasks,
          byId: {},
        },
      };
    case actionTypes.GET_STUDENT_ACADEMIC_REPORT:
      return {
        ...state,
        academic_reports: {
          ...state.academic_reports,
          byId: {},
        },
        actionsloading: true,
      };
    case actionTypes.GET_STUDENT_LEARNING_BEHAVIOUR:
      return {
        ...state,
        learning_behaviour: {
          ...state.learning_behaviour,
          byId: {},
        },
        actionsloading: true,
      };
    case actionTypes.GET_STUDENT_LEARNING_GOALS:
      return {
        ...state,
        learning_goals: {
          ...state.learning_goals,
          byId: {},
        },
        actionsloading: true,
      };
    case actionTypes.GET_STUDENT_ABSENCE_SUMMARY:
      return {
        ...state,
        absence_summary: {
          ...state.absence_summary,
          byId: {},
        },
        actionsloading: true,
      };
    case actionTypes.GET_HOME_ROOM_COMMENTS:
      return {
        ...state,
        homeroom_comments: {
          ...state.homeroom_comments,
          byId: {},
        },
        actionsloading: true,
      };

    case actionTypes.FETCH_STUDENT_NOTES:
      return {
        ...state,
        studentNotes: {
          notes: {},
        },
        actionsloading: true,
        fetchStudentNotesLoading: true
      };
    case actionTypes.SEND_STUDENT_NOTE: {
      return {
        ...state,
        sendNote: {
          status: 'sending'
        },
        sendStudentNotesLoading: true,
      }
    }
    case actionTypes.GET_PLOT_COURSES_SUCCESS:
      return {
        ...state,
        plotcourses: {
          ...state.plotcourses,
          byId: action.payload.byId || {},
        },
        actionsloading: false,
      };
    case actionTypes.GET_PLOT_TASK_SUCCESS:
      return {
        ...state,
        plottasks: {
          ...state.plottasks,
          byId: action.payload.byId || {},
        },
        actionsloading: false,
      };
    case actionTypes.GET_STUDENT_ACADEMIC_REPORT_SUCCESS:
      const returnVal = action.payload.byId || {};

      return {
        ...state,
        academic_reports: {
          byId: returnVal,
        },
        actionsloading: false,
      };
    case actionTypes.GET_STUDENT_ABSENCE_SUMMARY_SUCCESS:
      return {
        ...state,
        absence_summary: {
          byId: action.payload.byId || {},
        },
        actionsloading: false,
      };
    case actionTypes.GET_STUDENT_LEARNING_BEHAVIOUR_BY_COURSE:
      return {
        ...state,
        learning_behaviour: {
          ...state.learning_behaviour,
          courseData: null,
        },
        actionsloading: true,
      };
    case actionTypes.GET_STUDENT_LEARNING_BEHAVIOUR_BY_COURSE_SUCCESS:
      return {
        ...state,
        learning_behaviour: {
          ...state.learning_behaviour,
          courseData: action.payload,
        },
        actionsloading: false,
      };
    case actionTypes.GET_STUDENT_LEARNING_BEHAVIOUR_SUCCESS:
      return {
        ...state,
        learning_behaviour: {
          byId: action.payload.byId || {},
        },
        actionsloading: false,
      };
    case actionTypes.GET_STUDENT_LEARNING_GOALS_SUCCESS:
      return {
        ...state,
        learning_goals: {
          byId: action.payload.byId || {},
        },
        actionsloading: false,
      };
    case actionTypes.GET_HOME_ROOM_COMMENTS_SUCCESS:
      return {
        ...state,
        homeroom_comments: {
          byId: action.payload.byId || {},
        },
        actionsloading: false,
      };
    case actionTypes.FETCH_CARER_STUDENTS_SUCCESS:
      return {
        ...state,
        carerStudents: {
          byId: action.payload.byId || {},
        },
        actionsloading: false,
      };
    case actionTypes.GET_STUDENT_LIST:
      return {
        ...state,
        actionsloading: true
      }
    case actionTypes.GET_STUDENT_LIST_SUCCESS:
      return {
        ...state,
        studentList: {
          studentListData: action.payload.listData[0].records || {},
        },
        actionsloading: false,
      };
    case actionTypes.APPEND_STUDENT_ARRAY:
      let list = [];
      let notes = { ...state.studentNotes.notes[0] };
      if (notes) {
        const list = [
          action.payload,
          ...(state.studentNotes.notes[0].records.notes || {}),
        ];
      }
      return {
        ...state,
        studentNotes: {
          notes: {
            0: {
              records: {
                notes: list || {},
                pre_signed_URL:
                  state.studentNotes.notes[0].records.pre_signed_URL,
              },
            },
          },
        },
        actionsloading: false,
      };
    case actionTypes.FETCH_STUDENT_NOTES_SUCCESS:
      return {
        ...state,
        studentNotes: {
          notes: action.payload.notes || {},
        },
        actionsloading: false,
        fetchStudentNotesLoading: false,
      };
    case actionTypes.SEND_STUDENT_NOTE_SUCCESS:
      return {
        ...state,
        sendNote: {
          status: 'sent',
        },
        actionsloading: false,
        sendStudentNotesLoading: false,
      };
    case actionTypes.GET_PLOT_COURSES_FAILED:
    case actionTypes.GET_PLOT_TASK_FAILED:
    case actionTypes.GGET_STUDENT_ACADEMIC_REPORT_FAILED:
    case actionTypes.GET_STUDENT_ABSENCE_SUMMARY_FAILED:
    case actionTypes.GET_STUDENT_LEARNING_BEHAVIOUR_FAILED:
    case actionTypes.GET_STUDENT_LEARNING_GOALS_FAILED:
    case actionTypes.GET_HOME_ROOM_COMMENTS_FAILED:
    case actionTypes.FETCH_CARER_STUDENTS_FAILED:
    case actionTypes.GET_STUDENT_LIST_FAIL:
    case actionTypes.SEND_STUDENT_NOTE_FAIL:
      return {
        ...state,
        error: action.payload,
        actionsloading: false,
      };
    default:
      return state;
  }
}
